import { getRequest } from '../request/request.service';
import {
  UserCallHistoryResponse,
  UserProfile,
  UserProfileData,
} from './user-profile.service.types';

const USERS_URL = 'users';

export function getUser(userId: number) {
  return getRequest<UserProfile>(`/${USERS_URL}/${userId}`);
}

// `Document.profile.last.json_content` for the user, scoped via DocumentPolicy.
// Returns [] when no profile document exists for the user.
export function getUserProfileData(userId: number) {
  return getRequest<UserProfileData>(`/${USERS_URL}/${userId}/profile_data`);
}

// Conversation history rollup keyed by user_id. The CRM endpoint paginates
// the historical calls (`history_calls`) but always returns the latest call
// in `last_call` so callers can render a "current contact" summary without a
// separate fetch.
export function getUserCallHistory(userId: number) {
  return getRequest<UserCallHistoryResponse>(`/${USERS_URL}/${userId}/call_history`);
}
